import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { MenuUpdateService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchMenuUpdate = createAsyncThunk(
    'menuUpdate/fetchMenuUpdate',
    async ({ id, filesToKeep, file, title, slug, parentMenuId, menuGroupId, sort, specialField1 }) => {
        const response = await MenuUpdateService(id, file, title, slug, parentMenuId, menuGroupId, sort, filesToKeep, specialField1)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const menuUpdateSlice = createSlice({
    name: 'menuUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMenuUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMenuUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchMenuUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default menuUpdateSlice.reducer;
